import React, { Component } from 'react';
import { map } from 'lodash';

import { Select, TimePicker, Upload, message } from 'antd';
import moment from 'moment-timezone';
import * as yup from 'yup';
import {errorHandle} from "../../../Common/errorHandle";


const { Option } = Select;
class AddUser extends Component {
  state = {
    hours_of_work: [
      {
        key: 'Sunday',
        day: 'sun',
        start_time: '',
        end_time: '',
        enable: false
      },
      {
        key: 'Monday',
        day: 'mon',
        start_time: '',
        end_time: '',
        enable: false
      },
      {
        key: 'Tuesday',
        day: 'tues',
        start_time: '',
        end_time: '',
        enable: false
      },
      {
        key: 'Wednesday',
        day: 'wed',
        start_time: '',
        end_time: '',
        enable: false
      },
      {
        key: 'Thursday',
        day: 'thurs',
        start_time: '',
        end_time: '',
        enable: false
      },
      {
        key: 'Friday',
        day: 'fri',
        start_time: '',
        end_time: '',
        enable: false
      },
      {
        key: 'Saturday',
        day: 'sat',
        start_time: '',
        end_time: '',
        enable: false
      }
    ],
    group: { uuid: '', name: '' },
    user: {
      first_name: '',
      last_name: '',
      email: '',
      franchise_uuid: '',
      is_active: true,
      photo: '',
      description: ''
    },
    phone_numbers: {
      uuid: '',
      phone: '',
      type: 'mobile',
      can_send_sms: true,
      primary: true
    },
    is_add_user_Active: false,
    errors: {}
  }

  componentDidMount = () => {
    const {user} = this.state;
    const {franchise_uuid, is_disable_franchise, is_account_corporate} = this.getLoggedInUserRole();
    if (is_disable_franchise || is_account_corporate) Object.assign(user, {franchise_uuid})
    this.setState({user})
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    // message.destroy();
    //Add User
    if (Object.keys(props.AddUser.data).length > 0 && props.AddUser.data !== this.props.AddUser.data) {
      // success message or action
      props.userDrawerToggle(false);
      this.resetComponent();
      this.props.getUserList({ 'offset': 0, 'limit': 15 });

    }
    if (Object.keys(props.AddUser.errors).length > 0 && props.AddUser.errors !== this.props.AddUser.errors) {
      // display error messsage
      errorHandle(props?.AddUser?.errors)
    }
    this.setState({ loader: false });
  }

  // get logged in user
  getLoggedInUserRole = () => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)

    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner')
    const is_account_corporate = logged_in_user_role?.includes('accounting_corporate')
    const is_business_dev_franchiese = logged_in_user_role?.includes('business_dev_franchiese')
    const is_operations_mgr = logged_in_user_role?.includes('operations_mgr')
    // const is_field_tech = logged_in_user_role?.includes('field_tech')
    const franchise_uuid = authUser?.user?.field_offices?.map(x => x.uuid);
    return {franchise_uuid: franchise_uuid?.[0], is_account_corporate, is_disable_franchise: (is_franchise_owner || is_business_dev_franchiese || is_operations_mgr)}
  }

  //User detil setup
  onUserDetailChange = (e) => {
    let { user } = this.state;
    user = Object.assign(user, { [e.target.name]: e.target.value });
    this.setState({
      user
    })
  }

  //Working hours change
  onWorkingHoursChange = (e, hour, index) => {
    let { hours_of_work } = this.state;
    if(e.target.checked) {
      hours_of_work[index].enable = e.target.checked;
      hours_of_work[index].start_time = moment('09:00 AM','HH:mm A');
      hours_of_work[index].end_time = moment('05:00 PM','HH:mm A')
    }
    else {
      hours_of_work[index].enable = e.target.checked;
      hours_of_work[index].start_time = '';
      hours_of_work[index].end_time = ''
    }
    
    this.setState({
      hours_of_work
    })


  }

  // on Working Time Change
  onTimeChange = (e, type, hour) => {
    let { hours_of_work } = this.state;

    let index = hours_of_work.findIndex(x => x.key === hour.key);
    hours_of_work[index][type] = e;
    this.setState({
      hours_of_work
    })
  }

  //User Form Validation
  validateUser = () => {
    var self = this;
    setTimeout(() => {
      let {
        hours_of_work,
        user, phone_numbers, group } = self.state;
      const UserSchema = yup.object().shape({
        user: yup.object().shape({
          first_name: yup.string().required("First name is required"),
          last_name: yup.string().required("Last name is required"),
          email: yup.string().required("Email is required").email('Your Email is invalid.'),
          // franchise_uuid: yup.string().required("Franchise is required"),
          role: yup.string().required("Role is required"),
        }),
        phone_numbers: yup.object().shape({
          phone: yup.string().trim().matches(/^[0-9]{0}(?:[0-9]{10})?$/, 'Please enter a valid Phone Number.')
        }),
        group: yup.object().shape({
          name: yup.string().required("Group name is required"),
        }),
        // hours_of_work: yup.array().of(
        //   yup.object().shape({
        //     start_time: yup.string().when(['enable'], {
        //       is: true,
        //       then: yup.string().required('Start time is required'),
        //     }),
        //     end_time: yup.string().when(['enable'], {
        //       is: true,
        //       then: yup.string().required('End time is required'),
        //     }),
        //   })
        // )
      })


      const UserData = {
        user, phone_numbers, group,
        //  hours_of_work
      }

      // check validity
      let IsValid;
      let err_data = {};
      UserSchema.isValid(UserData)
        .then(function (valid) {
          IsValid = valid
        });

      setTimeout(() => {
        if (IsValid) {

          let hours = [];
          if (user?.role?.includes('field_tech')) {
            map(hours_of_work, x => {
              if (x.enable) {
                if (x.start_time && x.end_time) hours.push(x)
              }
            })
          }

          if (user?.role?.includes('field_tech') && hours?.length === 0) {
            self.setState({
              errors: { hours_of_work: 'Hours of work is required' }
            })
          } else {
            self.setState({ errors: {} })
            self.addUser()
          }
        }
        else {
          UserSchema.validate(UserData, { abortEarly: false })
            .catch(function (err) {
              map(err.inner, (item) => {
                err_data[item.path] = item.message;
              })
              // console.log("err_data::::>", err_data)
              self.setState({
                errors: err_data,
              })

            });
        }
      }, 100);
    }, 300);
  }

  // user photo selection
  userPhotoUpload = (info) => {
    let { user } = this.state;
    var self = this;
    const reader = new FileReader();
    reader.onloadend = function () {
      user = Object.assign(user, { 'photo': reader.result });
      self.setState({ user });
    }
    reader.readAsDataURL(info.file);


  }


  // convert images to base64
  getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  //Add New User
  addUser = () => {
    let { user, hours_of_work, group, phone_numbers } = this.state;
    let temp_hours_of_work = []


    map(hours_of_work, (item, i) => {
      if (hours_of_work[i]['start_time'] && hours_of_work[i]['end_time']) {
        temp_hours_of_work.push({
          day: hours_of_work[i]['day'],
          start_time: moment(hours_of_work[i]['start_time']).format('HH:mm:ss A'),
          end_time: moment(hours_of_work[i]['end_time']).format('HH:mm:ss A'),
          enable: true
        })

      }
      else {

        temp_hours_of_work.push({
          day: hours_of_work[i]['day'],
          start_time: null,
          end_time: null,
          enable: false
        })
      }

    })

    let temp_phone_numbers = [];
    if (phone_numbers?.phone !== ''){
      temp_phone_numbers.push(phone_numbers);
    }

    map(temp_phone_numbers, x => {
      if (!x.uuid) delete x?.uuid
    })

    let data = {
      ...user,
      hours_of_work: temp_hours_of_work,
      phone_numbers: temp_phone_numbers,
      group,

    }

    this.setState({
      loader: true
    })

    if (data?.franchise_uuid === '') {
      const {franchise_uuid, is_disable_franchise} = this.getLoggedInUserRole();
      if (is_disable_franchise) Object.assign(data, {franchise_uuid})
      else delete data.franchise_uuid
    }
    console.log("Add User : ",data);
    this.props.addUser(data)

  }



  // reset Component
  resetComponent = () => {
    this.setState({
      hours_of_work: [
        {
          key: 'Sunday',
          day: 'sun',
          start_time: '',
          end_time: '',
          enable: false
        },
        {
          key: 'Monday',
          day: 'mon',
          start_time: '',
          end_time: '',
          enable: false
        },
        {
          key: 'Tuesday',
          day: 'tues',
          start_time: '',
          end_time: '',
          enable: false
        },
        {
          key: 'Wednesday',
          day: 'wed',
          start_time: '',
          end_time: '',
          enable: false
        },
        {
          key: 'Thursday',
          day: 'thurs',
          start_time: '',
          end_time: '',
          enable: false
        },
        {
          key: 'Friday',
          day: 'fri',
          start_time: '',
          end_time: '',
          enable: false
        },
        {
          key: 'Saturday',
          day: 'sat',
          start_time: '',
          end_time: '',
          enable: false
        }
      ],
      group: { uuid: '', name: '' },
      user: {
        first_name: '',
        last_name: '',
        email: '',
        franchise_uuid: '',
        is_active: true,
        photo: '',
        description: ''
      },
      phone_numbers: {
        uuid: '',
        phone: '',
        type: 'mobile',
        can_send_sms: true,
        primary: true
      },
      errors: {}
    })
  }
  render() {
    let { loader, user, phone_numbers, errors, hours_of_work, group } = this.state;
    let { franchiseList, groupList, roleList } = this.props;
    const {is_disable_franchise} = this.getLoggedInUserRole()
    return (
      <React.Fragment>
        <div className="add_user_wrapper rdrawer">
          <div className="card-row">
            <div className="left-sec card-half">
              <h4>Add User</h4>
              <div className="form-group">
                <div className="fitem">
                  <label htmlFor="">First Name</label>
                  <input
                    type="text"
                    placeholder="First Name"
                    name="first_name"
                    value={user.first_name}
                    onChange={(e) => { this.onUserDetailChange(e) }} />
                  {errors['user.first_name'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['user.first_name']}</label> : ''}
                </div>

                <div className="fitem">
                  <label htmlFor="">Last Name</label>
                  <input
                    type="text"
                    placeholder="Last Name"
                    name="last_name"
                    value={user.last_name}
                    onChange={(e) => { this.onUserDetailChange(e) }} />
                  {errors['user.last_name'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['user.last_name']}</label> : ''}
                </div>

                <div className="fitem">
                  <label htmlFor="">Phone number</label>
                  <div className={phone_numbers.phone ? 'fix_isd_code' : ''}>
                    {phone_numbers.phone ? <span>+1</span> : ''}
                    <input
                      style={{marginLeft: phone_numbers?.phone ? "10px" : "0px"}}
                      type="text"
                      placeholder="Phone number"
                      name="phone_numbers"
                      value={phone_numbers?.phone}
                      inputMode="numeric"
                      max='10'
                      maxLength='10'
                      onPaste={(event) => {
                        if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                          event.preventDefault();
                        }
                      }}
                      onKeyPress={(e) => {
                        const pattern = /[0-9]/;
                        const inputChar = String.fromCharCode(e.charCode);
                        if (!pattern.test(inputChar)
                        ) {
                          // invalid character, prevent input
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        let { phone_numbers } = this.state;
                        phone_numbers = Object.assign(phone_numbers, { 'phone': e.target.value });
                        this.setState({
                          phone_numbers
                        })
                      }} />
                    {errors['phone_numbers.phone'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['phone_numbers.phone']}</label> : ''}
                  </div>


                </div>

                <div className="fitem">
                  <label htmlFor="">Email Address</label>
                  <input
                    type="email"
                    placeholder="Email Address"
                    name="email"
                    value={user.email}
                    onChange={(e) => { this.onUserDetailChange(e) }} />
                  {errors['user.email'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['user.email']}</label> : ''}
                </div>

                <div className="fitem">
                  <label htmlFor="">Franchise</label>
                  <Select
                    value={user.franchise_uuid || undefined}
                    style={{ 'width': '100%' }}
                    placeholder="Please Select"
                    onChange={(e) => {
                      let { user } = this.state;
                      user = Object.assign(user, { 'franchise_uuid': e });
                      this.setState({ user }, () => {
                        this.setState({loader: true, group: { 'uuid': '', 'name': '' }})
                        if(user.role?.includes('service_rep') || !this.state.user?.franchise_uuid){
                          this.props.getGroupList({ 'offset': 0, 'limit': 15, 'is_public': true });
                        } else {
                          this.props.getGroupList({ 'offset': 0, 'limit': 15, field_office__uuid: this.state.user?.franchise_uuid || '' });
                        }
                      })
                    }}
                    disabled={is_disable_franchise ? true : false}
                  >
                    {map(franchiseList, (item, i) => {
                      return (
                        <Option key={i} value={item.uuid}>{item.name}</Option>
                      )
                    })}

                  </Select>
                </div>

                <div className="fitem">
                  <label htmlFor="">Group</label>
                  <Select

                    style={{ 'width': '100%' }}
                    placeholder="Please Select"
                    value={group.name || undefined}
                    // eslint-disable-next-line
                    onChange={({ }, e) => {
                      this.setState({
                        group: { 'uuid': e.value, 'name': e.children }
                      })
                    }}
                  >
                    {groupList.filter(item => item.status === 'active').map((item, i) => {
                      return (
                        <Option key={i} value={item.uuid} >{item.name}</Option>
                      )
                    })}
                  </Select>
                  {errors['group.name'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['group.name']}</label> : ''}
                </div>

                <div className="fitem">
                  <label htmlFor="">Roles</label>
                  <Select
                    value={user.role || undefined}
                    style={{ 'width': '100%' }}
                    placeholder="Roles"
                    onChange={(e) => {
                      let { user } = this.state;
                      let role = [];
                      role.push(e)
                      user = Object.assign(user, { role });
                      this.setState({ user });
                      if(user.role?.includes('service_rep') || !this.state.user?.franchise_uuid){
                        this.props.getGroupList({ 'offset': 0, 'limit': 15, 'is_public': true });
                        this.setState({
                          group: {}
                        })
                      } else {
                        this.props.getGroupList({ 'offset': 0, 'limit': 15, field_office__uuid: this.state.user?.franchise_uuid || '' });
                      }
                    }}
                  >
                    {map(roleList, (item, i) => {
                      return (
                        <Option key={i} value={item.name}>{item.display_name}</Option>
                      )
                    })}
                  </Select>
                  {errors['user.role'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['user.role']}</label> : ''}
                </div>
              </div>
              <div className="hours-work-wrap mt-20">
                <h5>Hours of work</h5>
                {map(hours_of_work, (item, i) => {
                  // console.log(`${errors}hours_of_work[${i}].end_time`,errors[`hours_of_work[0].end_time`])
                  return (
                    <div className="fitem inline-check-list gcheck" key={i}>
                      <div className="fitem-check flex mb-10 ai-center">
                        <div className="hours-week">
                          <input type="checkbox"
                            className="fitem-ck-input"
                            id={`hours${i}`}
                            checked={hours_of_work[i].enable || false}
                            onChange={(e) => { this.onWorkingHoursChange(e, hours_of_work[i], i) }}

                          />
                          <label htmlFor={`hours${i}`} className="fitem-ck-txt mb-0">{item.key}</label>
                        </div>
                        <div className="flex">
                          <div className="fitem">
                            <TimePicker
                              suffixIcon={<i className="las la-angle-down"></i>}
                              format="hh:mm A"
                              minuteStep={15}
                              placeholder="From"
                              ref={`start_time${i}`}
                              disabled={!hours_of_work[i]['enable']}
                              value={hours_of_work[i].start_time === "" ? null : hours_of_work[i].start_time}
                              allowClear={false}
                              onChange={(e) => { this.onTimeChange(e, 'start_time', hours_of_work[i]) }}
                            />
                          </div>
                          <div className="fitem">
                            <TimePicker
                              suffixIcon={<i className="las la-angle-down"></i>}
                              placeholder="To"
                              format="hh:mm A"
                              minuteStep={15}
                              allowClear={false}
                              disabled={!hours_of_work[i]['enable']}
                              value={hours_of_work[i].end_time === "" ? null : hours_of_work[i].end_time}
                              onChange={(e) => { this.onTimeChange(e, 'end_time', hours_of_work[i]) }}
                            />
                          </div>
                        </div>
                        {errors[`hours_of_work${[i]}.end_time`] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors[`hours_of_work${[i]}.end_time`]}</label> : ''}
                      </div>

                      <div>

                      </div>
                    </div>
                  )
                })}
                {errors?.['hours_of_work'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['hours_of_work']}</label> : ''}
              </div>

              <div className="fitem">
                <label htmlFor="">Status</label>
                <Select
                  value={user.is_active}
                  defaultValue="true"
                  style={{ 'width': '100%' }}
                  placeholder="Status"
                  onChange={(e) => {
                    let { user } = this.state;
                    user = Object.assign(user, { 'is_active': e });
                    this.setState({ user })
                  }}
                >
                  <Option value={true}>Active</Option>
                  <Option value={false}>InActive</Option>
                </Select>
              </div>
            </div>
            <div className="img_upload right-sec card-half">
              <h4>User’s Bio</h4>
              <blockquote className="horiz">
                <b>The customer will see this information about you!</b>
                <p className="m-0"> As a field tech, customers will see who has serviced their property; and as a customer care rep, when you reply to tickets, customers will know who they are talking to!</p>
              </blockquote>

              <div className="file_upload_section flex ai-center flex-start">
                {
                  user.photo ?
                    <div className="uploded_img">
                      <img src={user.photo} alt="" className="user_img" />
                    </div>
                    :
                    <Upload
                      name="avatar"
                      listType="picture-card"
                      className="avatar-uploader"
                      showUploadList={false}
                      beforeUpload={() => false}
                      onChange={(e) => { this.userPhotoUpload(e) }}>

                      <div className="upload_text">
                        <i className="las la-plus-circle"></i>
                        <p>Upload Photo Optional</p>
                      </div>
                    </Upload>

                }
                {user.photo ?
                  <div className="action-btn">
                    <Upload
                      name="avatar"

                      showUploadList={false}
                      beforeUpload={() => false}
                      onChange={(e) => { this.userPhotoUpload(e) }}
                    >
                      <button className="btn btn-bdr btn-xs mr-2" type="button">Replace</button>
                    </Upload>

                    <button type="button"
                      className="btn btn-bdr btn-danger btn-xs"
                      onClick={() => {
                        let { user } = this.state
                        user = Object.assign(user, { 'photo': '' });
                        this.setState({
                          user,
                          is_new_img: true
                        })
                      }}>Remove</button>
                  </div> : ''}

              </div>

              <div className="fitem">
                <label>a little about me</label>
                <textarea
                  value={user.description || ''}
                  name="description"
                  placeholder="Be personable! "
                  rows="4"
                  onChange={(e) => { this.onUserDetailChange(e) }}></textarea>
              </div>
            </div>
          </div>

          <div className="footer" style={{'width':'411px'}}>
            <button className="btn btn-primary" onClick={() => {
              this.props.userDrawerToggle(false)
              this.resetComponent()
            }}>Cancel</button>
            <button
              // className={!is_add_user_Active ? 'btn disabled' : 'btn btn-warning'}
              className="btn btn-warning"
              // disabled={!is_add_user_Active}
              onClick={() => { this.validateUser() }}
            >Add User</button>
          </div>
        </div>
        {
          loader ?
            <div className='loader_wrapper'>
              < div className='loader07' ></div >
            </div >
            : ''
        }
      </React.Fragment>
    );
  }
}

export default AddUser;